import React from 'react';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router';
import { IconButton, Badge } from '@mui/material';
import { Iconify } from '../../../../shared/components/base';
import { useAdminMessages } from '../../../../modules/messages/hooks';
import { unreadParentMessagesAtom, unreadTeacherMessagesAtom } from '../../../../shared/state/atoms';
import useParentList from '../../../../modules/parents/ParentList/hooks/useParentList';
import useTeacherList from '../../../../modules/teachers/TeacherList/hooks/useTeacherList';
import { PATH_DASHBOARD } from '../../../../shared/routes/paths';

const MessagesAlert = () => {
  const navigate = useNavigate();
  const { useGetAllParentTeacherAdminConversations } = useAdminMessages();
  const { teacherList } = useTeacherList();
  const { parentList } = useParentList();
  const [unreadParentMessages] = useAtom(unreadParentMessagesAtom);
  const [unreadTeacherMessages] = useAtom(unreadTeacherMessagesAtom);

  useGetAllParentTeacherAdminConversations(parentList, teacherList);
  return (
    <>
      <IconButton
        color="primary"
        onClick={() => {
          navigate(PATH_DASHBOARD.messages);
        }}
      >
        <Badge badgeContent={(unreadParentMessages?.length ?? 0) + (unreadTeacherMessages?.length ?? 0)} color="error">
          <Iconify icon="eva:email-outline" width={30} height={30} />
        </Badge>
      </IconButton>
    </>
  );
};

export default MessagesAlert;
